import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type BlogArticleFragment = { id: string, pk: number, body: string, title: string, slug: string, authorName: string | null, dateAdded: any, annotation: string, datePublished: any | null, status: string, averageRating: number, userMeasure: number, keywords: string, tags: string, bigThumbnail: string | null, mediumThumbnail: string | null, smallThumbnail: string | null, bigThumbnailWebp: string | null, mediumThumbnailWebp: string | null, smallThumbnailWebp: string | null, author: { id: string, pk: number }, image: { url: string } };

export const BlogArticleFragmentDoc = gql`
    fragment BlogArticleFragment on BlogArticleType {
  id
  pk
  body
  title
  slug
  authorName
  dateAdded
  annotation
  datePublished
  status
  averageRating
  userMeasure
  keywords
  tags
  author {
    id
    pk
  }
  bigThumbnail: thumbnailUrl(size: "1600x900", method: CROP)
  mediumThumbnail: thumbnailUrl(size: "640x360", method: CROP)
  smallThumbnail: thumbnailUrl(size: "320x180", method: CROP)
  bigThumbnailWebp: thumbnailUrl(size: "1600x900", method: CROP_WEBP)
  mediumThumbnailWebp: thumbnailUrl(size: "640x360", method: CROP_WEBP)
  smallThumbnailWebp: thumbnailUrl(size: "320x180", method: CROP_WEBP)
  image {
    url
  }
}
    `;